import { useQuery } from '@ltvco/refresh-lib/vendors';

import { DEFAULT_QUERY_OPTIONS, useBaseCourtApi } from './useBaseCourtApi';

export const useOralArgumentDetails = (id: string | undefined) => {
  const { getOralArgument, isLoading: isTokenLoading } = useBaseCourtApi();

  const oralArgumentQuery = useQuery(
    ['oral-argument', id],
    () => (id ? getOralArgument(id) : null),
    {
      ...DEFAULT_QUERY_OPTIONS,
      enabled: !!id && !isTokenLoading,
    }
  );

  return {
    oralArgumentQuery,
    isLoading: oralArgumentQuery.isLoading || isTokenLoading,
    isError: oralArgumentQuery.isError,
    error: oralArgumentQuery.error,
    data: oralArgumentQuery.data,
  };
};
